import {
    AfterViewInit,
    Component,
    ElementRef,
    Input, OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { RemoteConfigService } from '../../services/remote-config.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChannelsService } from '../../services/channels.service';


@Component({
	selector: 'video-thumb-show-details',
	templateUrl: './video-thumb-show-details.component.html',
	styleUrls: ['./video-thumb-show-details.component.scss']
})
export class VideoThumbShowDetailsComponent implements OnInit, OnDestroy {

	@Input() media: any
	routerLink: string[];
    progress: number;
    position: string;

	@ViewChild('thumb')
	thumb: ElementRef;

    destroy$: Subject<void> = new Subject<void>();


	constructor(public readonly config: RemoteConfigService,
                private readonly channelService: ChannelsService) {
	}

	async ngOnInit() {

        if (this.media.images) {
            this.media.image = this.media.images.find(x => x.type === 'thumbnail')?.url;
        }

        this.channelService.watchHistory().pipe(takeUntil(this.destroy$)).subscribe(res => {
            this.watchHistory(res);
        });

		this.routerLink = this.getRouterLink();
	}

    ngOnDestroy() {
        this.destroy$.next();
    }

    private getRouterLink(): string[] {
		if (this.media.seasonId !== undefined) {
			return ['/season', this.media.seasonId];
		}
		return ['/video', this.media.mediaId];
	}

    watchHistory(history: any[]) {
        if (history && history.length > 0) {
            let result = history.find(f => f.mediaId == this.media.mediaId);
            if (result) {
                this.progress = result.percentage;
            }
        }
    }
}
